import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";
import { RESOURCES } from "./NavigationConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `/`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "login-alt",
    path: `/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "login-1",
    path: `${AUTH_PREFIX_PATH}/login-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login-1")
    ),
  },
  {
    key: "login-2",
    path: `${AUTH_PREFIX_PATH}/login-2`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login-2")
    ),
  },
  {
    key: "register-1",
    path: `${AUTH_PREFIX_PATH}/register-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-1")
    ),
  },
  {
    key: "register-2",
    path: `${AUTH_PREFIX_PATH}/register-2`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-2")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "error-page-1",
    path: `${AUTH_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
  },
  {
    key: "error-page-2",
    path: `${AUTH_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
  },
];

export const protectedRoutes = [
  // Set Password (for temporary password flow)
  {
    key: "set-password",
    path: `${AUTH_PREFIX_PATH}/set-password`,
    component: React.lazy(() =>
      import("views/auth-views/components/SetPasswordForm")
    ),
    meta: {
      blankLayout: true
    }
  },
  // Profile and Account routes
  {
    key: "profile",
    path: `${APP_PREFIX_PATH}/profile`,
    component: React.lazy(() => import("views/app-views/profile")),
  },
  {
    key: "change-password",
    path: `${APP_PREFIX_PATH}/change-password`,
    component: React.lazy(() => import("views/app-views/change-password")),
  },
  // Dashboard
  {
    key: "app-dashboard",
    path: `${APP_PREFIX_PATH}/dashboard`,
    component: React.lazy(() => import("views/app-views/sab/dashboard")),
    permission: { resource: RESOURCES.DASHBOARD, action: 'read' },
  },
  // Learning / French PR
  {
    key: "app-learning-courses",
    path: `${APP_PREFIX_PATH}/learning/courses`,
    component: React.lazy(() => import("views/app-views/sab/learning/courses")),
    permission: { resource: RESOURCES.LEARNING, action: 'read' },
  },
  {
    key: "app-learning-levels",
    path: `${APP_PREFIX_PATH}/learning/levels`,
    component: React.lazy(() => import("views/app-views/sab/learning/levels")),
    permission: { resource: RESOURCES.LEARNING, action: 'read' },
  },
  {
    key: "app-learning-modules",
    path: `${APP_PREFIX_PATH}/learning/modules`,
    component: React.lazy(() => import("views/app-views/sab/learning/modules")),
    permission: { resource: RESOURCES.LEARNING, action: 'read' },
  },
  {
    key: "app-learning-lessons",
    path: `${APP_PREFIX_PATH}/learning/lessons`,
    component: React.lazy(() => import("views/app-views/sab/learning/lessons")),
    permission: { resource: RESOURCES.LEARNING, action: 'read' },
  },
  {
    key: "app-learning-lesson-editor",
    path: `${APP_PREFIX_PATH}/learning/lessons/:id/edit`,
    component: React.lazy(() => import("views/app-views/sab/learning/lesson-editor")),
    permission: { resource: RESOURCES.LEARNING, action: 'update' },
  },
  {
    key: "app-learning-students",
    path: `${APP_PREFIX_PATH}/learning/students`,
    component: React.lazy(() => import("views/app-views/sab/learning/student-progress")),
    permission: { resource: RESOURCES.LEARNING, action: 'read' },
  },
  {
    key: "app-learning-entitlements",
    path: `${APP_PREFIX_PATH}/learning/entitlements`,
    component: React.lazy(() => import("views/app-views/sab/learning/entitlements")),
    permission: { resource: RESOURCES.LEARNING, action: 'update' },
  },
  {
    key: "app-learning-plans",
    path: `${APP_PREFIX_PATH}/learning/plans`,
    component: React.lazy(() => import("views/app-views/sab/learning/plans")),
    permission: { resource: RESOURCES.LEARNING, action: 'update' },
  },
  {
    key: "app-learning-ordering",
    path: `${APP_PREFIX_PATH}/learning/ordering`,
    component: React.lazy(() => import("views/app-views/sab/learning/ordering")),
    permission: { resource: RESOURCES.LEARNING, action: 'update' },
  },
  {
    key: "app-learning-assessments",
    path: `${APP_PREFIX_PATH}/learning/assessments`,
    component: React.lazy(() => import("views/app-views/sab/learning/assessments")),
    permission: { resource: RESOURCES.LEARNING, action: 'read' },
  },
  {
    key: "app-learning-content-pages",
    path: `${APP_PREFIX_PATH}/learning/content-pages`,
    component: React.lazy(() => import("views/app-views/sab/learning/content-pages")),
    permission: { resource: RESOURCES.LEARNING, action: 'update' },
  },
  {
    key: "app-learning-payments",
    path: `${APP_PREFIX_PATH}/learning/payments`,
    component: React.lazy(() => import("views/app-views/sab/learning/payments")),
    permission: { resource: RESOURCES.LEARNING, action: 'update' },
  },
  {
    key: "app-learning-promoters",
    path: `${APP_PREFIX_PATH}/learning/promoters`,
    component: React.lazy(() => import("views/app-views/sab/learning/promoters")),
    permission: { resource: RESOURCES.LEARNING, action: 'update' },
  },
  {
    key: "app-learning-test-practice",
    path: `${APP_PREFIX_PATH}/learning/test-practice`,
    component: React.lazy(() => import("views/app-views/sab/learning/test-practice")),
    permission: { resource: RESOURCES.LEARNING, action: 'read' },
  },
  {
    key: "app-learning-english-speaking",
    path: `${APP_PREFIX_PATH}/learning/english-speaking`,
    component: React.lazy(() => import("views/app-views/sab/learning/english-speaking")),
    permission: { resource: RESOURCES.LEARNING, action: 'read' },
  },
  {
    key: "app-learning-ai-examiner",
    path: `${APP_PREFIX_PATH}/learning/ai-examiner`,
    component: React.lazy(() => import("views/app-views/sab/learning/ai-examiner")),
    permission: { resource: RESOURCES.LEARNING, action: 'read' },
  },
  {
    key: "app-learning-seed",
    path: `${APP_PREFIX_PATH}/learning/seed`,
    component: React.lazy(() => import("views/app-views/sab/learning/seed")),
    adminOnly: true,
  },
  // User Management (Administration)
  {
    key: "app-users",
    path: `${APP_PREFIX_PATH}/admin/users`,
    component: React.lazy(() => import("views/app-views/sab/users")),
    permission: { resource: RESOURCES.USERS, action: 'read' },
  },
  // Backup & Restore
  {
    key: "app-backups",
    path: `${APP_PREFIX_PATH}/admin/backups`,
    component: React.lazy(() => import("views/app-views/sab/backups")),
    adminOnly: true,
  },
  // Maintenance Mode
  {
    key: "app-maintenance",
    path: `${APP_PREFIX_PATH}/admin/maintenance`,
    component: React.lazy(() => import("views/app-views/sab/maintenance")),
    adminOnly: true,
  },
];
